var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('following-settings-view',{attrs:{"subject-id":_vm.SUBJECT_ID},on:{"updateWelcomeMessage":_vm.updateWelcomeMessage,"saveWelcomeMessage":function($event){_vm.saveWelcomeMessage = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }